
/**
 * Making sure path is always a string and never undefined.
 * SCS.datalayer handels sanitization internally by
 * implicitly calling SCS.tealium.sanitizeString.
 *
 * @returns string
 */
export function getPagePath(path : any) : string {
	if(typeof path === 'string') {
		return path;
	}

	if(path === undefined) {
		return window.location.pathname;
	}

	// Ok now we do the best we can...
	return String(path);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/datalayer.ts